// extracted by mini-css-extract-plugin
export default {"tileGrid":"WV4C5__tileGrid"};